import { DeliveryTypeCategory } from '@/features/orders/constants/app'
import { FormInput } from '@/features/pos/components/OrderFinalization/form/types'
import { PosMode } from '@/features/pos/types'

export const getDefaultValues = (
    posMode: PosMode,
    deliveryTypeCategory: DeliveryTypeCategory
): FormInput => {
    if (posMode === 'pos') {
        return { deliveryTypeCategory, note: null, automaticContainerRemovals: [] }
    }

    return {
        deliveryTypeCategory,
        customer: null,
        deliveryTime: null,
        note: null,
        automaticContainerRemovals: [],
    }
}
